import { Divider, Grid, TextField, Typography } from '@mui/material';
import React, { useContext, useState } from 'react'
import contactStyles from "../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import globalStyles from "../../../../../assets/styles/global.module.scss";
import intentStyles from "../../../../../assets/styles/componentStyles/intentStyles/intentStyle.module.scss";
import Required from '../../../../utility/required';
import { ColorPicker } from 'material-ui-color';
import GlobalButton from '../../../../utility/globalButton/button';
import { useShallow } from 'zustand/react/shallow';
import { useTicketStore } from '../../../../../store/ticketStore';
import { createSubStatusPayload, ticketStatusData, updateSubStatusPayload } from '../../../../../models/axiosModel';
import { getTicketSubStatusObj } from '../constants';
import { isValidCssColor } from '../../../../../utils/constants';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import agent from '../../../../../services/api';
import { useGenericStore } from '../../../../../store/genericStore';

interface CreateSubStatusPopupProps {
    getTicketStatusListApiCall: () => Promise<void>,
}  

const CreateSubStatusPopup: React.FC<CreateSubStatusPopupProps> = (props) => {
    
    const { getTicketStatusListApiCall } = props;

    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const { setSelectedSubStatus, setFlagCreateSubStatusPopup, selectedSubStatus } = useTicketStore(
        useShallow((state) => ({
            setSelectedSubStatus: state.setSelectedSubStatus,
            setFlagCreateSubStatusPopup: state.setFlagCreateSubStatusPopup,
            selectedSubStatus: state.selectedSubStatus
        }))
    )

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [payload, setPayload] = useState<ticketStatusData>(selectedSubStatus ? selectedSubStatus : getTicketSubStatusObj('', ''));

    const onChangeOfField = (key: keyof ticketStatusData, value: string) => {
        setPayload((prev) => ({
            ...prev,
            [key]: value
        }))
    }

    const checkDisableCreateBtn = () => {
        if(!payload?.ticket_status_name?.trim() || !isValidCssColor(payload?.ticket_status_color)){
            return true;
        }
        return false;
    }

    const onClickOfCancelBtn = () => {
        setFlagCreateSubStatusPopup(false);
        setSelectedSubStatus(null);
    }

    const onClickOfCreateBtn = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        let res;
        const createStatusPayload: createSubStatusPayload = {
            ticket_status_name: payload?.ticket_status_name,
            ticket_status_color: payload?.ticket_status_color
        }
        if(selectedSubStatus){
            const updateStatusPayload: updateSubStatusPayload = {
                ...createStatusPayload,
                ticket_status_id: selectedSubStatus?.ticket_status_id
            }
            res = await agent.updateTicketSubStatus.put(updateStatusPayload);
        } else {
            res = await agent.createTicketSubStatus.post(createStatusPayload);
        }

        if(!(res.status)){
            handleError(res);
        } else {
            const successMessage = `Ticket Substatus ${selectedSubStatus ? 'Updated' : 'Created'} Successfully`;
            showSuccess(successMessage)
            getTicketStatusListApiCall();
        }
        onClickOfCancelBtn();
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    const getPopupTitle = () => {
        let title = 'Create Substatus';
        if(selectedSubStatus){
            title = `Edit Substatus - ${selectedSubStatus?.ticket_status_name}`;
        }
        return title;
    }
    
    return (
        <>
            <Grid container >
                <Grid item xs={12}>
                    <Grid container direction={"column"} justifyContent={"center"}>
                        <Grid item textAlign={"center"}>
                            <Typography className={contactStyles.popupTitleTypography}>
                                {getPopupTitle()}
                            </Typography>
                        </Grid>

                        <Divider className={contactStyles.popupTitleDivider} />

                        <Grid item>
                            <Grid container className={contactStyles.popupBodyGridContainer} gap={2}>
                                <Grid item xs={12}>
                                    <Grid container gap={"12px"}>
                                        <Grid item xs={12}>
                                            <Typography className={contactStyles.popupFieldTypography}>
                                                Name <Required /> 
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                value={payload?.ticket_status_name}
                                                onChange={(e) => onChangeOfField('ticket_status_name', e.target.value)}
                                                placeholder='Enter Name'
                                                className={`${contactStyles.campaignContactPopupTextField} ${globalStyles.fullwidth}`}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container gap={"12px"}>
                                        <Grid item xs={12}>
                                            <Typography className={contactStyles.popupFieldTypography}>
                                                Color <Required /> 
                                            </Typography>
                                        </Grid>
                                         <Grid className={intentStyles.intentColorPicker} xs={12}>
                                            <ColorPicker
                                                value={typeof payload.ticket_status_color === 'string' ? payload.ticket_status_color : ''}
                                                onChange={(event: any) => {
                                                    let colorValue = "";
                                                    if (event.error) {
                                                        colorValue = event.raw;
                                                    }
                                                    else if (event.css && event.css.backgroundColor) { 
                                                        colorValue = event.css.backgroundColor;
                                                    } else if (event.target && event.target.value) {
                                                        colorValue = event.target.value;
                                                    } else {
                                                        colorValue = event;
                                                    }
                                                    onChangeOfField('ticket_status_color', colorValue);
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid item xs={12} className={globalStyles.fullwidth}>
                            <Grid container justifyContent={"center"} alignItems={"center"} gap={"12px"} sx={{ padding: "20px 0" }}>
                                <Grid item>
                                    <GlobalButton
                                        buttonText="Cancel"
                                        sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                        className='borderedButtonStyle'
                                        onClick={() => onClickOfCancelBtn()}
                                    />
                                </Grid>
                                <Grid item>
                                    <GlobalButton
                                        buttonText={selectedSubStatus ? 'Save' : 'Create'}
                                        sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                        className='primaryButtonStyle' 
                                        disabled={checkDisableCreateBtn()}
                                        onClick={() => onClickOfCreateBtn()}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default CreateSubStatusPopup
